import React from 'react';

const KnownPeopleTab = ({ person, updateField }) => {
  const knownPeople = person.knownPeople || [];

  const addKnownPerson = () => {
    updateField('knownPeople', [...knownPeople, { Name: '', level: 'casual' }]);
  };

  const updateKnownPerson = (index, field, value) => {
    const updated = [...knownPeople];
    updated[index] = { ...updated[index], [field]: value };
    updateField('knownPeople', updated);
  };

  const removeKnownPerson = (index) => {
    updateField('knownPeople', knownPeople.filter((_, i) => i !== index));
  };

  return (
    <div className="max-w-4xl mx-auto space-y-4 p-4">
      <div className="tech-card p-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="tech-section-title flex items-center gap-2">
            <svg className="w-4 h-4 text-tech-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            KNOWN CONNECTIONS
          </h3>
          <button onClick={addKnownPerson} className="tech-btn-secondary py-1.5 text-xs">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            ADD
          </button>
        </div>

        {knownPeople.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-tech-textDim text-sm">NO CONNECTIONS DEFINED</p>
          </div>
        ) : (
          <div className="space-y-3">
            {knownPeople.map((kp, index) => (
              <div key={index} className="flex items-start gap-3 p-3 bg-tech-surface rounded-lg">
                <div className="w-10 h-10 rounded bg-tech-accent/10 border border-tech-accent/30 flex items-center justify-center shrink-0">
                  <span className="text-tech-accent font-mono text-sm">
                    {kp.Name?.charAt(0)?.toUpperCase() || '?'}
                  </span>
                </div>
                <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-3">
                  <input
                    type="text"
                    value={kp.Name}
                    onChange={(e) => updateKnownPerson(index, 'Name', e.target.value)}
                    placeholder="Name"
                    className="tech-input"
                  />
                  <select
                    value={kp.level || 'casual'}
                    onChange={(e) => updateKnownPerson(index, 'level', e.target.value)}
                    className="tech-input"
                  >
                    <option value="close">CLOSE</option>
                    <option value="friend">FRIEND</option>
                    <option value="casual">CASUAL</option>
                    <option value="professional">PROFESSIONAL</option>
                  </select>
                </div>
                <button
                  onClick={() => removeKnownPerson(index)}
                  className="p-2 text-tech-textMuted hover:text-tech-danger rounded transition shrink-0"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default KnownPeopleTab;
